import React from 'react';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputAdornment from "@material-ui/core/InputAdornment";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { Divider, Hidden } from '@material-ui/core';

import ContactMail from "@material-ui/icons/ContactMail";
import Email from "@material-ui/icons/Email";
import Phone from "@material-ui/icons/Phone";

import { store } from '../../../redux/store';
import { ADD_CUSTOMER_FORM_CHANGE } from '../../../redux/types';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

class ContactStateObject {
    name = "";
    nameState = "";
    surname = "";
    surnameState = "";
    contact_number = "";
    contact_numberState = "";
    email = "";
    emailState = "";
}

class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            business: props.defaultBusiness || new ContactStateObject(),
            technical: props.defaultTechnical || new ContactStateObject(),
            financial: props.defaultFinancial || new ContactStateObject()
        };
        
        this.state.business.nameState = this.state.business.name ? "success" : "";
        this.state.technical.nameState = this.state.technical.name ? "success" : "";
        this.state.financial.nameState = this.state.financial.name ? "success" : "";

        this.state.business.surnameState = this.state.business.surname ? "success" : "";
        this.state.technical.surnameState = this.state.technical.surname ? "success" : "";
        this.state.financial.surnameState = this.state.financial.surname ? "success" : "";

        this.state.business.emailState = this.state.business.email && this.verifyEmail(this.state.business.email) ? "success" : "";
        this.state.technical.emailState = this.state.technical.email && this.verifyEmail(this.state.technical.email) ? "success" : "";
        this.state.financial.emailState = this.state.financial.email && this.verifyEmail(this.state.financial.email) ? "success" : "";

        this.state.business.contact_numberState = this.state.business.contact_number && this.verifyMobile(this.state.business.contact_number) ? "success" : "";
        this.state.technical.contact_numberState = this.state.technical.contact_number && this.verifyMobile(this.state.technical.contact_number) ? "success" : "";
        this.state.financial.contact_numberState = this.state.financial.contact_number && this.verifyMobile(this.state.financial.contact_number) ? "success" : "";
    }
    sendState() {
        return this.state;
    }
    verifyEmail(value) {
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
            return true;
        }
        return false;
    }
    verifyMobile(value) {
        var phoneRex = /^\d{10,20}$/
        if (phoneRex.test(value)) {
            return true;
        }
        return false;
    }
    verifyLength(value, length) {
        if (value.length >= length) {
            return true;
        }
        return false;
    }
    change = (event, name, type = "required", contactType) => {

        var new_state = { [name + "State"]: this.state[contactType][name + "State"] };

        switch (type) {
            case "required":
                if (event.target.value) {
                    new_state[name + "State"] = "success";
                } else {
                    new_state[name + "State"] = "error";
                }
                break;
            case "email":
                if (this.verifyEmail(event.target.value)) {
                    new_state[name + "State"] = "success";
                } else {
                    new_state[name + "State"] = "error";
                }
                break;
            case "phone":
                if (this.verifyMobile(event.target.value)) {
                    new_state[name + "State"] = "success";
                } else {
                    new_state[name + "State"] = "error";
                }
                break;
            default:
                break;
        }

        if(this.props.isPrepaid)
            new_state[name + "State"] = "success";
        
        this.setState({ [contactType]: { ...this.state[contactType], ...new_state, [name]: event.target.value } });
        store.dispatch({ type: ADD_CUSTOMER_FORM_CHANGE, name, payload: event.target.value, subtype: contactType });
    }
    isValidated() {
        console.log(this.state);
        if (
            this.state.business.nameState === "success" &&
            this.state.technical.nameState === "success" &&
            this.state.financial.nameState === "success" &&
            this.state.business.surnameState === "success" &&
            this.state.technical.surnameState === "success" &&
            this.state.financial.surnameState === "success" &&
            this.state.business.emailState === "success" &&
            this.state.technical.emailState === "success" &&
            this.state.financial.emailState === "success" &&
            this.state.business.contact_numberState === "success" &&
            this.state.technical.contact_numberState === "success" &&
            this.state.financial.contact_numberState === "success"
            || this.props.isPrepaid
        ) {
            return true;
        } else {

            var new_business = { ...this.state.business };
            var new_technical = { ...this.state.technical };
            var new_financial = { ...this.state.financial };

            if (this.state.business.nameState !== "success") {
                new_business = { ...new_business, nameState: "error" };
            }
            if (this.state.technical.nameState !== "success") {
                new_technical = { ...new_technical, nameState: "error" };
            }
            if (this.state.financial.nameState !== "success") {
                new_financial = { ...new_financial, nameState: "error" };
            }

            if (this.state.business.surnameState !== "success") {
                new_business = { ...new_business, surnameState: "error" };
            }
            if (this.state.technical.surnameState !== "success") {
                new_technical = { ...new_technical, surnameState: "error" };
            }
            if (this.state.financial.surnameState !== "success") {
                new_financial = { ...new_financial, surnameState: "error" };
            }

            if (this.state.business.emailState !== "success") {
                new_business = { ...new_business, emailState: "error" };
            }
            if (this.state.technical.emailState !== "success") {
                new_technical = { ...new_technical, emailState: "error" };
            }
            if (this.state.financial.emailState !== "success") {
                new_financial = { ...new_financial, emailState: "error" };
            }

            if (this.state.business.contact_numberState !== "success") {
                new_business = { ...new_business, contact_numberState: "error" };
            }
            if (this.state.technical.contact_numberState !== "success") {
                new_technical = { ...new_technical, contact_numberState: "error" };
            }
            if (this.state.financial.contact_numberState !== "success") {
                new_financial = { ...new_financial, contact_numberState: "error" };
            }

            this.setState({ business: new_business, technical: new_technical, financial: new_financial })
        }
        return false;
    }
    render() {
        const { classes } = this.props;
        return (
            <GridContainer justify="center">
                <GridItem xs={12} sm={12}>
                    <h4 className={classes.infoText}>
                        Contact Information
                    </h4>
                </GridItem>
                <GridItem xs={11} sm={11} md={11} lg={5}>
                    <h4><ContactMail style={{ marginBottom: -5 }} />&nbsp;&nbsp;&nbsp;Business Contact</h4>
                    <Divider variant="middle" />
                    <CustomInput
                        success={this.state.business.nameState === "success"}
                        error={this.state.business.nameState === "error"}
                        labelText={
                            <span>
                                Name <small>(required)</small>
                            </span>
                        }
                        id="business.name"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "name", "required", "business"),
                            // endAdornment: (
                            //     <InputAdornment
                            //         position="end"
                            //         className={classes.inputAdornment}
                            //     >
                            //         <Email className={classes.inputAdornmentIcon} />
                            //     </InputAdornment>
                            // )
                            value: this.state.business.name,
                        }}
                    />
                    <CustomInput
                        success={this.state.business.surnameState === "success"}
                        error={this.state.business.surnameState === "error"}
                        labelText={
                            <span>
                                Surname <small>(required)</small>
                            </span>
                        }
                        id="business.surname"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "surname", "required", "business"),
                            // endAdornment: (
                            //     <InputAdornment
                            //         position="end"
                            //         className={classes.inputAdornment}
                            //     >
                            //         <Email className={classes.inputAdornmentIcon} />
                            //     </InputAdornment>
                            // )
                            value: this.state.business.surname,
                        }}
                    />
                    <CustomInput
                        success={this.state.business.emailState === "success"}
                        error={this.state.business.emailState === "error"}
                        labelText={
                            <span>
                                Email <small>(required)</small>
                            </span>
                        }
                        id="business.email"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "email", "email", "business"),
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className={classes.inputAdornment}
                                >
                                    <Email className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            ),
                            value: this.state.business.email,
                        }}
                    />
                    <CustomInput
                        success={this.state.business.contact_numberState === "success"}
                        error={this.state.business.contact_numberState === "error"}
                        labelText={
                            <span>
                                Contact Number <small>(required)</small>
                            </span>
                        }
                        id="business.contact_number"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "contact_number", "phone", "business"),
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className={classes.inputAdornment}
                                >
                                    <Phone className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            ),
                            value: this.state.business.contact_number,
                        }}
                    />
                </GridItem>
                <Hidden xlUp>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                        <Divider variant="middle" style={{ marginTop: 20, marginTop: 20 }} />
                    </GridItem>
                </Hidden>
                <GridItem xs={11} sm={11} md={11} lg={5}>
                    <h4><ContactMail style={{ marginBottom: -5 }} />&nbsp;&nbsp;&nbsp;Technical Contact</h4>
                    <Divider variant="middle" />
                    <CustomInput
                        success={this.state.technical.nameState === "success"}
                        error={this.state.technical.nameState === "error"}
                        labelText={
                            <span>
                                Name <small>(required)</small>
                            </span>
                        }
                        id="technical.name"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "name", "required", "technical"),
                            // endAdornment: (
                            //     <InputAdornment
                            //         position="end"
                            //         className={classes.inputAdornment}
                            //     >
                            //         <Email className={classes.inputAdornmentIcon} />
                            //     </InputAdornment>
                            // )
                            value: this.state.technical.name,
                        }}
                    />
                    <CustomInput
                        success={this.state.technical.surnameState === "success"}
                        error={this.state.technical.surnameState === "error"}
                        labelText={
                            <span>
                                Surname <small>(required)</small>
                            </span>
                        }
                        id="technical.surname"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "surname", "required", "technical"),
                            // endAdornment: (
                            //     <InputAdornment
                            //         position="end"
                            //         className={classes.inputAdornment}
                            //     >
                            //         <Email className={classes.inputAdornmentIcon} />
                            //     </InputAdornment>
                            // )
                            value: this.state.technical.surname,
                        }}
                    />
                    <CustomInput
                        success={this.state.technical.emailState === "success"}
                        error={this.state.technical.emailState === "error"}
                        labelText={
                            <span>
                                Email <small>(required)</small>
                            </span>
                        }
                        id="technical.email"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "email", "email", "technical"),
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className={classes.inputAdornment}
                                >
                                    <Email className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            ),
                            value: this.state.technical.email,
                        }}
                    />
                    <CustomInput
                        success={this.state.technical.contact_numberState === "success"}
                        error={this.state.technical.contact_numberState === "error"}
                        labelText={
                            <span>
                                Contact Number <small>(required)</small>
                            </span>
                        }
                        id="technical.contact_number"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "contact_number", "phone", "technical"),
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className={classes.inputAdornment}
                                >
                                    <Phone className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            ),
                            value: this.state.technical.contact_number,
                        }}
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Divider variant="middle" style={{ marginTop: 20, marginTop: 20 }} />
                </GridItem>
                <GridItem xs={11} sm={11} md={11} lg={5}>
                    <h4><ContactMail style={{ marginBottom: -5 }} />&nbsp;&nbsp;&nbsp;Financial Contact</h4>
                    <Divider variant="middle" />
                    <CustomInput
                        success={this.state.financial.nameState === "success"}
                        error={this.state.financial.nameState === "error"}
                        labelText={
                            <span>
                                Name <small>(required)</small>
                            </span>
                        }
                        id="financial.name"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "name", "required", "financial"),
                            // endAdornment: (
                            //     <InputAdornment
                            //         position="end"
                            //         className={classes.inputAdornment}
                            //     >
                            //         <Email className={classes.inputAdornmentIcon} />
                            //     </InputAdornment>
                            // )
                            value: this.state.financial.name,
                        }}
                    />
                    <CustomInput
                        success={this.state.financial.surnameState === "success"}
                        error={this.state.financial.surnameState === "error"}
                        labelText={
                            <span>
                                Surname <small>(required)</small>
                            </span>
                        }
                        id="financial.surname"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "surname", "required", "financial"),
                            // endAdornment: (
                            //     <InputAdornment
                            //         position="end"
                            //         className={classes.inputAdornment}
                            //     >
                            //         <Email className={classes.inputAdornmentIcon} />
                            //     </InputAdornment>
                            // )
                            value: this.state.financial.surname,
                        }}
                    />
                    <CustomInput
                        success={this.state.financial.emailState === "success"}
                        error={this.state.financial.emailState === "error"}
                        labelText={
                            <span>
                                Email <small>(required)</small>
                            </span>
                        }
                        id="financial.email"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "email", "email", "financial"),
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className={classes.inputAdornment}
                                >
                                    <Email className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            ),
                            value: this.state.financial.email,
                        }}
                    />
                    <CustomInput
                        success={this.state.financial.contact_numberState === "success"}
                        error={this.state.financial.contact_numberState === "error"}
                        labelText={
                            <span>
                                Contact Number <small>(required)</small>
                            </span>
                        }
                        id="financial.contact_number"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "contact_number", "phone", "financial"),
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className={classes.inputAdornment}
                                >
                                    <Phone className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            ),
                            value: this.state.financial.contact_number,
                        }}
                    />
                </GridItem>
            </GridContainer>
        );
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(Contact);